import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------Globals--------------- */
import { Card, Text } from "react-native-paper";

/* -----------------UI--------------- */
import { Box } from "@memorang/ui";

/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "@hooks/useAppTheme";

import { useAppStore } from "@hooks/useAppStore";
import useClerkUser from "@hooks/useClerkUser";
/* -----------------Child components--------------- */
import {
	AutoRedeemContentView,
	type Purchase,
} from "components/AutoRedeemContentView";

type Props = {
	products: Purchase[];
	examName: string;
	title: string;
	successfulPurchaseTitle?: string;
	externalPurchase?: boolean;
};
export const AccessGrantedView = ({
	products,
	examName,
	title,
	successfulPurchaseTitle,
	externalPurchase,
}: Props) => {
	const { email } = useClerkUser();
	const theme = useAppTheme();
	const appFont = useAppStore((store) => store.app.font) || "opensans";

	return (
		<Box paddingBottom={24} paddingHorizontal={16} flex={1}>
			<Card>
				<Card.Content
					style={{
						paddingHorizontal: 8,
					}}
				>
					<Box gap={16}>
						<Icon
							name="check-circle"
							size={44}
							style={{
								alignSelf: "center",
							}}
							color={theme.colors.success.main}
						/>
						<Text
							variant="titleMedium"
							style={{
								textAlign: "center",
								paddingHorizontal: 16,
								fontFamily: `${appFont}-semibold`,
							}}
						>
							{title}
						</Text>
						<AutoRedeemContentView
							purchases={products}
							redeemedProductsExamName={examName}
							redeemStatus="redeemed"
							email={email}
							externalPurchase={externalPurchase}
							successfulPurchaseTitle={successfulPurchaseTitle}
						/>
					</Box>
				</Card.Content>
			</Card>
		</Box>
	);
};
